import { jsonToCSV } from "react-papaparse";
import Button from "@mui/material/Button";
import { AdminData, OutputAdminSerial } from "./AdminListApi";
import { useTranslation } from "react-i18next";
import { isJp } from "../i18n/LangUtil";
import { format } from "date-fns";
import { useCategoryForView } from "../common/utils/Utils";

interface AdminExportButtonProps {
  adminData: AdminData;
}

const FILE_NAME_DATE_FORMAT = "yyyyMMddHHmmss";

export const AdminListExportButton = (jsonData: AdminExportButtonProps): JSX.Element => {
  const { t, i18n } = useTranslation();

  const createExportData = () => {
    const result: OutputAdminSerial[] = [];
    const headerData: OutputAdminSerial = {
      tenantId: t("common.tenantId"),
      tenantName: t("admin.companyName"),
      name: t("common.owner"),
      loginMailAddress: t("common.emailAddress"),
      useCategory: t("admin.useCategory"),
      country: t("admin.country"),
      serialNumber: t("common.serialNumber"),
    };
    for (const opt of jsonData.adminData.options) {
      const optName: string = isJp(i18n) ? opt.nameJa : opt.nameEn;
      headerData["licenseNumber" + opt.id] = `${optName} ${t("common.licenseNumber")}`;
      headerData["licenseAt" + opt.id] = `${optName} ${t("admin.licenseAt")}`;
    }
    result.push(headerData);

    jsonData.adminData.list.forEach((item) => {
      const outputData: OutputAdminSerial = {
        tenantId: item.tenantId,
        tenantName: item.tenantName,
        name: `${item.familyName || t("admin.removed")} ${item.givenName || ""}`,
        loginMailAddress: `${item.loginMailAddress || t("admin.removed")}`,
        country: `${item.country || t("admin.removed")}`,
        useCategory: `${useCategoryForView(item.useCategory, t) || t("admin.removed")}`,
        serialNumber: item.serialNumber,
      };
      for (const opt of jsonData.adminData.options) {
        outputData["licenseAt" + opt.id] = item["licenseAt" + opt.id] as string;
        outputData["licenseNumber" + opt.id] = item["licenseNumber" + opt.id] as string;
      }

      result.push(outputData);
    });

    return result;
  };

  const downloadDataFile = () => {
    const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
    const createdJsonData = createExportData();
    const text = jsonToCSV(createdJsonData, { quotes: true, header: false });
    const blob = new Blob([bom, text], { type: "text/csv" });
    const link = document.createElement("a");
    const currentDateStr = format(new Date(), FILE_NAME_DATE_FORMAT);
    link.download = `customer_data_${currentDateStr}.csv`;
    link.href = URL.createObjectURL(blob);
    link.click();
    URL.revokeObjectURL(link.href);
  };

  return (
    <Button variant="contained" onClick={() => downloadDataFile()}>
      {t("admin.exportButton")}
    </Button>
  );
};
